var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash-screen"},[_c('img',{attrs:{"alt":"FairPay","src":require("@/assets/fairpay-splash.png")}}),_c('el-container',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }